/* React */
import React from "react";

/* Components */
import ChartLabel from "src/components/charts/chart-label/ChartLabel";

/* Constants */
import { ChartType } from "src/shared/constants/charts/Chart";

/* Interfaces */
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";
import { DescriptiveStatisticsProps } from "src/shared/interfaces/DescriptiveStatistics";
import { SurvivalAnalysisProps } from "src/shared/interfaces/SurvivalAnalysis";
import { TreatmentPatternsProps } from "src/shared/interfaces/TreatmentPatterns";

const createLabel = (
  data: BaseChartProps<
    | DescriptiveStatisticsProps
    | SurvivalAnalysisProps
    | TreatmentPatternsProps,
    ChartType[] | ChartType[][]
  >,
  featureOrCohort?: string,
  total: number = data.total,
  totalCohortSize: number | undefined = data.totalCohortSize,
  notLookedForCount: number | undefined = data.notLookedForCount,
  lookedForNoValueCount: number | undefined = data.lookedForNoValueCount,
  lookedForNoValueTotal: number | undefined = data.lookedForNoValueTotal
) => {
  const label = {
    total,
    totalCohortSize,
    lookedForNoValueTotal,
    notLookedForCount,
    lookedForNoValueCount,
    label: featureOrCohort,
  };

  return <ChartLabel {...label} />;
};

export default createLabel;
